<div class="cce-header-nbc-vehicle">
  <div class="cce-col" id="admin-menu" [ngStyle]="{'width' : (numberPage == 0) ? '85%':'100%'}"
    style="padding-left: 15px;">
    <div class="cce-row flat breadcrumb" style="height: 30%; margin-top: 20px">
      <a class="header-label" [class]="(numberPage > 0)?'clickable-breadcrump':'active'" (click)="goToDefault()">ADMIN
        PANEL</a>
      <div class="cce-row" *ngIf="isAppAdmin">
        <div class="verticalDelimiter" style="margin-top: 10px; margin-left: 15px;"></div>
        <a class="header-label" [class]="(numberPage == 0)?'clickable-breadcrump':'active'"
          (click)="goToConfigured()">ACTIVE CUSTOMERS</a>
      </div>
    </div>
    <div *ngIf="(numberPage == 0)" class="cce-row" style="height: 70% ;padding-top: 20px;">
      <a class="admin-panel-button" (click)="onClickOpenForm()">New User</a>
      <a [ngClass]="(this.selectedRows.length > 0)?'admin-panel-button':'admin-panel-delete-button'"
        (click)="onDeleteUser()">Delete User</a>
      <span class="cce-spacer"></span>
      <div class="cce-row">

        <input type="file" ng2FileSelect (change)="upload($event)" (uploader)="uploader" hidden #myUpload />
        <button id="fileUploadButton" style="margin-right: 20px;" mat-raised-button (click)="myUpload.click()"
          class="admin-import-button">IMPORT</button>
        <div class="verticalDelimiter"></div>
        <mat-select class="admin-leasing-button" [(ngModel)]="selectedValue" (selectionChange)="changeStatus()">
          <mat-option class="cce-option" *ngFor="let f of financing" [value]="f">
            {{ getFinancingName(f) }}
          </mat-option>
        </mat-select>
        <div class="verticalDelimiter"></div>
      </div>
    </div>

    <div *ngIf="(numberPage == 1)" class="cce-row" style="margin-left: 80%; height: 70% ;padding-top: 20px;">
      <div class="verticalDelimiter"></div>
      <button id="fileUploadButton" style="margin:0px 20px;" mat-raised-button (click)="export()"
        class="admin-import-button">EXPORT</button>
      <div class="verticalDelimiter"></div>
    </div>

  </div>
  <div *ngIf="(numberPage == 0)" class="cce-col" id="admin-checkbox"
    style="width: 15% ;padding-left: 15px;padding-top: 10px; margin-top: 20px">
    <li *ngFor="let option of filterMenu" class="admin-checkboxes">
      <mat-checkbox class="admin-checkbox" (change)="changeStatus()" [(ngModel)]="option.isChecked">
        {{getFieldname(option.name)}}
      </mat-checkbox>
    </li>
  </div>

</div>


<mat-card class="availableCarsGrid">
  <mat-card-content style="height: 100%;width: 100%">
    <div *ngIf="(numberPage == 0)" style="height: 100%;width: 100%">
      <ag-grid-angular myGrid id="admin-panel-grid" class="ag-theme-balham"
        (cellDoubleClicked)="onCellDoubleClicked($event)" [gridOptions]="gridOptionsSpecs"> </ag-grid-angular>
    </div>
    <div *ngIf="(numberPage > 0)" style="height: 100%;width: 100%">
      <ag-grid-angular id="admin-panel-grid" class="ag-theme-balham" [gridOptions]="gridOptionsSpecsAC">
      </ag-grid-angular>
    </div>

  </mat-card-content>
</mat-card>
